import { useState, useCallback, useRef, useEffect } from 'react'
import { connect } from 'react-redux'

import { ProvidersClaimsTable } from '../../../../claim-history/providers-table'
import { IGAO } from '../../../../igao'

import MedicalTeam from './medicalComponents'
import Organizations from './organizationComponents'

function MedicalDemographics (props) {
  const { patientId } = props

  let [ key, setKey ] = useState(0)
  let refetchRef = useRef()

  let submitCallback = useCallback(() => {
    setKey(key => key + 1)
  }, [])

  let handleProvidersTableMount = useCallback(refetch => {
    refetchRef.current = refetch
  }, [])

  useEffect(() => {
    refetchRef.current?.()
  }, [ key ])

  return (
    <div className='main'>
      <MedicalTeam
        formKey={key}
        patientId={patientId}
        onSubmit={submitCallback}
      />
      <Organizations
        formKey={key}
        patientId={patientId}
        onSubmit={submitCallback}
      />

      <ProvidersClaimsTable
        onAction={submitCallback}
        onMount={handleProvidersTableMount}
      />

      <IGAO
        key={key}
        path='provider_network'
      />
    </div>
  )
}

const mapStateToProps = redux => {
  return {
    patientId: redux?.globalVars?.params?.id
  }
}

export default connect(mapStateToProps)(MedicalDemographics)
